// @flow

const TEMPLATE_CUSTOM_PROPERTIES: 'properties' = 'properties';
export default TEMPLATE_CUSTOM_PROPERTIES;
